import {observer, PropTypes as MobxPropTypes} from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import inject from '../../hoc/injectHoc';
import LoadingIcon from '../../common/loadingIcon/LoadingIcon';

import {parseSearchParams} from '../../../utils/routeHelper';
import FlowRenderer from './components/flowRenderer/FlowRenderer';

import './userPaymentPage.scss';

/**
 * The UserPaymentPage component.
 */
export class UserPaymentPage extends React.Component {
  /**
   * Triggered when the component is first mounted to the page.
   */
  componentDidMount() {
    this.initializeFromParams(this.props.location.search);
  }

  /**
   * Triggered when the component updates.
   *
   * @param {{}} prevProps
   */
  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      this.initializeFromParams(this.props.location.search);
    }
  }

  /**
   * Parses URL search params and initializes the purchase flow store.
   *
   * @param {string} search
   */
  async initializeFromParams(search) {
    const {purchaseFlowStore} = this.props;

    const {
      planId,
      downloadCreditQty,
      requestCreditQty,
      monthlyMediaPlayerQty,
      lifetimeMediaPlayerQty,
    } = parseSearchParams(search);

    await purchaseFlowStore.initialize({
      planId,
      downloadCreditQty,
      requestCreditQty,
      monthlyMediaPlayerQty,
      lifetimeMediaPlayerQty,
    });
  }

  /**
   * Whether the interior query param is set to true.
   *
   * @returns {boolean}
   */
  get isInterior() {
    const {interior} = parseSearchParams(this.props.location.search);
    return interior === 'true';
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    const {purchaseFlowStore} = this.props;

    const {monthlyMediaPlayerQty, lifetimeMediaPlayerQty} = parseSearchParams(this.props.location.search);
    const productType = (monthlyMediaPlayerQty || lifetimeMediaPlayerQty) ? 'mediaPlayer' : 'plan';

    return (
      <div id="user-payment-page" className="system-page full-height container-fluid">
        {purchaseFlowStore.hasInitialized
          ? (
            <FlowRenderer productType={productType} showAddons={this.isInterior} />
          )
          : (
            <LoadingIcon />
          )
        }
      </div>
    );
  }
}

UserPaymentPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.object.isRequired,
  }).isRequired,
  purchaseFlowStore: MobxPropTypes.observableObject,
};

UserPaymentPage.wrappedComponent = {};
UserPaymentPage.wrappedComponent.propTypes = {
  purchaseFlowStore: MobxPropTypes.observableObject.isRequired,
};

export default inject(UserPaymentPage)(
  observer(UserPaymentPage)
);
